import type {
  ShowSalesRepInput,
  ShowSalesRepOutput,
} from '@snap-types/actions/show-sales-rep';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildV2SiteUrl } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [showSalesRep, useShowSalesRepQuery] = injectQuery<
  ShowSalesRepInput,
  ShowSalesRepOutput
>(`${QUOTE_BUILDER_SLICE_NAME}/showSalesRep`, ({ siteCode, salesRepId }) => ({
  url: buildV2SiteUrl(siteCode, `sales-rep/${salesRepId}`),
}));
